import CACHES_SHAPE from 'rlink-data-connector/storage/CACHES_SHAPE';
export default function lookup (caches, typeOrRequest, ...idOrArgs) {
  let storagePath = typeOrRequest.referenceFor(...idOrArgs).storagePath('resolved');
  return CACHES_SHAPE.getAt(
    caches,
    storagePath,
    [], // covered path
    //missing key:
    (incompleteObj, pathToIncompleteObj, missingKey, remainingPath) => {
      let fullPath = pathToIncompleteObj.concat([missingKey], remainingPath);
      if (fullPath.length === storagePath.length
          && fullPath[fullPath.length - 1] === 'resolved') {
        return typeOrRequest.emptyValue;
      } else {
        throw new Error('Missing key for lookup in CACHES_SHAPE - this should not ever happen.');
      }

    }
  );
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/lookup.js